import { EnvironmentMode } from 'types/env'

export const getEnvironmentMode = (): EnvironmentMode => import.meta.env.MODE as EnvironmentMode
